export const chartTypeOverylaySorter = (
  { chartType: chartTypeA }: { chartType: string },
  { chartType: chartTypeB }: { chartType: string }
) => {
  if (chartTypeA === "line" && chartTypeB === "bar") return -1;
  if (chartTypeA === "bar" && chartTypeB === "line") return 1;
  return 0;
};
